var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logoSetting&&_vm.logoSetting.logo_url)?_c('div',[_c('el-image',{style:(`width: ${_vm.logoSetting.width}px;height: ${_vm.logoSetting.height}px`),attrs:{"fit":"contain","src":`${_vm.logoSetting.logo_url}`,"alt":`平台LOGO`}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }